// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1942":"69c442cf","5993":"69c442cf"}[chunkId] + ".chunk.css";
};